export const DEFAULT_FONT_WEIGHT = 400;
const ITALIC_SUFFIX_LENGTH = 6; // 'italic'.length
const RADIX_DECIMAL = 10;

export function parseFontVariant(variant: string | undefined): {
  fontStyle: 'italic' | 'normal';
  fontWeight: number;
} {
  if (!variant || variant === 'regular') {
    return {
      fontStyle: 'normal',
      fontWeight: DEFAULT_FONT_WEIGHT,
    };
  }

  if (variant === 'italic') {
    return {
      fontStyle: 'italic',
      fontWeight: DEFAULT_FONT_WEIGHT,
    };
  }

  const isItalic = variant.endsWith('italic');
  const weightStr = isItalic ? variant.slice(0, -ITALIC_SUFFIX_LENGTH) : variant;
  const weight = Number.parseInt(weightStr, RADIX_DECIMAL);

  return {
    fontStyle: isItalic ? 'italic' : 'normal',
    fontWeight: Number.isNaN(weight) ? DEFAULT_FONT_WEIGHT : weight,
  };
}
